export default {
  homePage: {
    navBtnLinks: {
      blog: "Frederic-K's Blob",
      career: "Career",
      projects: "Projects",
      about: "About",
      contact: "Contact",
      linkedin: "LinkedIn",
      github: "GitHub",
      resume: "Resume",
    },
  },
}
